module.exports = __webpack_public_path__ + "img/boundingbox_en.ff35ced.jpg";